export const REQUEST = "REQUEST";
export const FAILURE = "FAILURE";
export const WARNING = "WARNING";
export const SUCCESS = "SUCCESS";
export const FULFILL = "FULFILL";
